import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TableRow, TableCell, Button, TableHead, TableBody, IconButton, Box, Grid } from '@material-ui/core';
import { DeleteRounded, AddRounded, EditRounded } from '@material-ui/icons';
import { isEmpty, size } from 'lodash';
import { Alert } from '@material-ui/lab';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';
import Currency from '../../../../../commonModules/Currency';
import InputText from '../../../../../commonModules/interface/form-input-inline';
import TableFooterPagination from '../../../../../commonModules/interface/TableFooterPagination';
import { ListLayout } from '../../containers/Layout';
import Dialog from '../../../../../commonModules/interface/Dialog';

const ListTransferReappro = (props) => {
    const fetchTransfers = useFetchTransfers("reapprovisionnement");
    const fetchDrafts = useFetchTransfers("draft");
    // const REAPPRO = useSelector((state) => state.inventory.sales.REAPPRO); 
    // const REA_DRAFTS = useSelector((state) => state.inventory.sales.REA_DRAFTS); 
    const SHOPS = useSelector((state) => state.inventory.shops); 
	const STATE = useSelector((state) => state.inventory.requestState); 
	const REAPPRO = useSelector((state) => state.inventory.sales.REAPPRO); 

    const [openUpdateTransport, setOpenUpdateTransport] = useState(false);
    const [transport, setTransport] = useState(0);
    const [taxes, setTaxes] = useState(0);
    const [updatedPurchase, setUpdatedPurchase] = useState({});
    const prevReapproCountRef = useRef(0);
    const isInitialMountRef = useRef(true);

    // Calculer le nombre de réappro de manière stable
    const reapproCount = useMemo(() => Object.keys(REAPPRO).length, [REAPPRO]);

    useEffect(() => {
        if (props.draft) {
            fetchDrafts();
        } else {
            if(isEmpty(REAPPRO)){
                fetchTransfers();
            } else {
                // Initialiser le compteur avec le nombre actuel de réappro
                prevReapproCountRef.current = reapproCount;
            }
        }
    }, []);

    // Marquer la fin du montage initial après le premier rendu
    useEffect(() => {
        isInitialMountRef.current = false;
    }, []);

    // Écouter les changements de REAPPRO pour rafraîchir la liste après création
    useEffect(() => {
        // Ignorer le premier rendu (montage initial)
        if (isInitialMountRef.current) {
            return;
        }
        
        if (!props.draft && !isEmpty(REAPPRO)) {
            // Rafraîchir seulement si le nombre de réappro a augmenté (création)
            if (reapproCount > prevReapproCountRef.current) {
                fetchTransfers();
            }
            prevReapproCountRef.current = reapproCount;
        }
    }, [reapproCount]);


    const updateTransportForm = (purchase) => {
        console.log('[INFO] change status', { purchase });
        setOpenUpdateTransport(true);
        setUpdatedPurchase(purchase);
        setTransport(purchase.transport);
        setTaxes(purchase.taxes);
    };

    const submitTransport = () => {
        console.log('[INFO] change status');
        const p = { ...updatedPurchase, transport: parseFloat(transport), taxes: parseFloat(taxes) };
        props.changeStatus(p);
        setOpenUpdateTransport(false);
        setTransport(0);
        setTaxes(0);
        setUpdatedPurchase({});
    };

    const createReapproList = (list) => {
        const { rowsPerPage, currentPage } = props;
        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((reappro) => {

            if (reappro) {
                const shopDest = SHOPS[reappro.shop_dest];
                const shop = SHOPS[reappro.shop_id];
                // const match_purchase = PURCHASES_REAPPRO[reappro.reappro_purchase_id];
                if (!shop) {
                    console.log('====================================');
                    console.log({ reappro });
                    console.log('====================================');
                }
                return (
                    <TableRow key={reappro.id}>
                        <TableCell>{(new Date(reappro.creation_date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>
                            <a href="#" onClick={() => props.handleSingleShop(shop)}> {shop && shop.name}</a>
                        </TableCell>
                        <TableCell>
                            <a href="#" onClick={() => props.handleSingleShop(shopDest)}> {shopDest && shopDest.name}</a>
                        </TableCell>
                        <TableCell>{reappro.comments}</TableCell>
                        {reappro.received &&
                            <TableCell>Reçu</TableCell>
                        }
                        {!reappro.received &&
                            <TableCell>
                                <Button
                                    disabled={STATE.purchases.fetching}
                                    color="secondary"
                                    variant="contained"
                                    onClick={() => updateTransportForm(reappro)}
                                >
                                    Valider Reception
                                </Button>
                            </TableCell>
                        }
                        <TableCell><Currency value={Math.round(reappro.total_price)} /></TableCell>
                        <TableCell>
                            <IconButton
                                color="secondary"
                                onClick={() => props.handleSingleSale(reappro, shop, shopDest)}
                            >
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            <IconButton
                                onClick={() => props.handleDelete(reappro)}
                            >
                                <DeleteRounded color="error" />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                );
            }
        });
    };

    const createReapproDraftList = (list) => {
        const { rowsPerPage, currentPage } = props;
        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((reappro) => {
            if (reappro) {
                const shopDest = SHOPS[reappro.shop_dest];
                const shop = SHOPS[reappro.shop_id];
                if (!shop) {
                    console.log('====================================');
                    console.log({ reappro });
                    console.log('====================================');
                }
                return (
                    <TableRow key={reappro.id}>
                        <TableCell>{(new Date(reappro.creation_date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>
                            <a href="#" onClick={() => props.handleSingleShop(shop)}> {shop && shop.name}</a>
                        </TableCell>
                        <TableCell>
                            <a href="#" onClick={() => props.handleSingleShop(shopDest)}> {shopDest && shopDest.name}</a>
                        </TableCell>
                        <TableCell>{reappro.comments}</TableCell>
                        <TableCell>
                            <IconButton
                                color="secondary"
                                onClick={() => props.handleSingleSale(reappro, shop, shopDest)}
                            >
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            <IconButton
                                onClick={() => props.handleDelete(reappro)}
                            >
                                <DeleteRounded color="error" />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                );
            }
        });
    };

    const displayList = () => {
        let listAll = [];
        let tab = [];
        let rows = 0;
        let filteredList = props.getFilteredList();
        rows = size(filteredList);
        tab = props.draft ? createReapproDraftList(filteredList) : createReapproList(filteredList);
        listAll = filteredList.map((sale) => sale.id);
        return { tab, size: rows, listAll };
    };

    const list = displayList();
    return (
        <Box>
            {openUpdateTransport &&
                <Dialog
                    open={true}
                    title="Validation Coût du transport"
                    submitAction={submitTransport}
                    close={() => setOpenUpdateTransport(false)}
                    maxWidth="xs"
                >
                    <Box p={1}>
                        <InputText
                            label="Transport"
                            value={transport}
                            type="number"
                            onChange={(e) => setTransport(e.target.value)}
                        />
                        <InputText
                            label="Taxes"
                            value={taxes}
                            type="number"
                            onChange={(e) => setTaxes(e.target.value)}
                        />
                    </Box>
                    <Alert severity="warning">
                        Après validation vous ne pourrez plus modifier cette info
                    </Alert>
                </Dialog>
            }

            <ListLayout>
                <TableHead>
                    <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Shop</TableCell>
                        <TableCell>Destination</TableCell>
                        <TableCell>Remarques</TableCell>
                        {!props.draft &&
                            <>
                                <TableCell>Statut</TableCell>
                                <TableCell>Total</TableCell>
                            </>
                        }
                        <TableCell>Détails</TableCell>
                        {props.draft &&
                            <TableCell>Modifier</TableCell>
                        }
                        <TableCell>Options</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.size > 0 &&
                        list.tab
                    }
                    {list.size === 0 &&
                        <TableRow>
                            <TableCell colSpan="8">
                                <div className="text-center">
                                    <h5>Pas de Reapprovisionnement pour le moment</h5>
                                    Cliquez sur <b className="onglet">"Nouveau"</b> Pour en créer un
                                </div>
                            </TableCell>
                        </TableRow>
                    }
                </TableBody>
                {list.size > 20 &&
                    <TableFooterPagination
                        colSpan={8}
                        count={list.size}
                        onChangePage={props.onChangePage}
                        initialPage={props.currentPage}
                    />
                }
            </ListLayout>
        </Box>
    );
};

export default ListTransferReappro;
